import { createReducer, on } from '@ngrx/store';
import { DeleteAnnouncementDialogState } from './delete-announcement-dialog.state';
import { deleteAnnouncementDialogStateInitial } from './delete-announcement-dialog.state.initial';
import { DeleteAnnouncementDialogActions } from './delete-announcement-dialog.actions';

/**
 * Reducer für den Delete-Announcement-Dialog.
 */
export const deleteAnnouncementDialogReducers = createReducer(
  deleteAnnouncementDialogStateInitial,

  on(
    DeleteAnnouncementDialogActions.open,
    (state, { item }): DeleteAnnouncementDialogState => ({
      ...state,
      isOpen: true,
      itemToDelete: item,
    }),
  ),

  on(
    DeleteAnnouncementDialogActions.close,
    (state): DeleteAnnouncementDialogState => ({
      ...state,
      isOpen: false,
      itemToDelete: undefined,
    }),
  ),

);
